import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {DateHelper} from '../../helper/date.helper';

export const minDateValidator =
    (minDate: string, message: string): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }
        const date: Date = DateHelper.isCorrectDateFormat(control.value)
            ? DateHelper.parseToDate(control.value)
            : DateHelper.INVALID_DATE;
        const minDateDate: Date = DateHelper.isCorrectDateFormat(minDate)
            ? DateHelper.parseToDate(minDate)
            : DateHelper.INVALID_DATE;
        // Wenn es kein gültiges Datum ist, soll dieser Validator nicht greifen
        if (date === DateHelper.INVALID_DATE || minDateDate === DateHelper.INVALID_DATE) {
            return null;
        }
        if (date.getTime() >= minDateDate.getTime()) {
            return null;
        }
        return {
            date: message
        };
    };
